<template>
  <el-dialog title="用户服务协议" :visible.sync="myResult" width="50%">
    <div>
      报名服务平台在此特别提醒用户认真阅读本《用户服务协议》（以下简称《服务协议》）。
      <p>1 服务条款的接受</p>
      <p>使用或访问本服务即表明您确认同意这些条款。如果您不同意本服务条款及/或随时对其的修改，您应不使用或主动取消系统提供的服务。您的使用行为将被视为您对本服务条款全部的接受，包括接受系统对服务条款随时所做的任何修改。 报名服务平台将不断推出新的服务，本服务条款适用于系统提供的各种服务，但当您使用系统某一特定服务时，如该服务另有单独的服务条款、指引或规则，您应遵守本服务条款及报名服务平台随时公布的与该服务相关的服务条款、指引或规则等。前述所有的指引和规则，均构成本服务条款的一部分。除非本服务条款另有其它明示规定，新推出的产品或服务、增加或强化目前本服务的任何新功能，均受到本服务条款的规范。</p>
      <p>2 服务条款的修改</p>
      <p>报名服务平台有权在必要时修改本服务条款, 服务条款一旦发生变动，将会在相关页面上公布修改后的服务条款。如果不同意所改动的条款，您应主动取消此项服务。如果您继续使用本服务，则视为接受服务条款的变动。</p>
      <p>3 服务说明</p>
      <p>
        用户应具有使用系统所必须的法律法规要求的所有资质，由于您缺少上述资质导致的全部法律责任，用户应自行承担。 用户必须遵守《计算机信息网络国际联网安全保护管理办法》、《中华人民共和国计算机信息网络国际联网管理暂行规定》、《中华人民共和国计算机信息系统安全保护条例》、《中华人民共和国电信条例》、《全国人大常委会关于维护互联网安全的决定》、《互联网信息服务管理办法》等国家有关法律、法规。 用户承诺不进行制作、复制、发布、传播含有下列内容的信息：反对宪法所确定的基本原则的；危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；损害国家荣誉和利益的；煽动民族仇恨、民族歧视，破坏民族团结的；破坏国家宗教政策，宣扬邪教和封建迷信的；散布谣言，扰乱社会秩序，破坏社会稳定的；散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；侮辱或者诽谤他人，侵害他人合法权益的；含有法律、行政法规禁止的其他内容的；并承诺不利用报名服务平台提供之服务实施危害电信网络安全和信息安全的行为，或实施扰乱电信市场秩序的行为。 用户保证妥善保管好在报名服务平台的账号及密码，如果造成帐户信息失密，由此给用户带来的损失，均由用户自己承担。用户应对任何人利用用户的账户信息所进行的活动负完全的责任，报名服务平台无法对非法或未经用户授权使用您的账户的行为作出甄别，因此不承担任何责任。 依本服务条款所取得的服务权利不可转让。 如用户违反国家法律法规或本服务条款，报名服务平台将有权停止向用户提供服务而不需承担任何责任，如导致报名服务平台遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求等，用户须向报名服务平台赔偿相应的损失，并需对其违反服务条款所产生的一切后果负全部法律责任。 关于收费服务，用户可以自行免费注册账号并在一定范围内免费使用报名服务平台提供的服务。如用户有超出范围的使用需求，请联系平台官方，我们竭诚帮您解决。
      </p>
      <p>4 服务风险及免责声明</p>
      <p>
       您需明白，本服务涉及到互联网及移动通讯等服务，鉴于计算机及互联网的特殊性，因黑客、病毒、Internet上通路的阻塞、电信部门技术或政策调整等造成的服务中断或不能满足用户要求的风险。开通服务的用户须承担以上风险。 报名服务平台在进行网络调整、优化和维护时，如果需短时间中断服务，您应尽到注意义务并调整使用系统服务。否则，报名服务平台不承担由此中断给用户造成的一切损失。 根据有关法律法规，报名服务平台在此郑重提醒您注意，任何经由本服务而发布、上传的文字、资料、音乐、照片、视讯、信息、用户登记的资料或其它资料（以下简称“内容 ”），无论系公开还是私下传送，均由内容提供者承担责任。在任何情况下，报名服务平台均不为内容负责，但平台有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停您使用本服务的全部，保存有关记录，并向有关机关报告。
      </p>
      <p>5 用户隐私制度</p>
      <p>
        用户提供的登记资料及服务平台保留的有关用户的若干其它资料将受到中国有关隐私的法律和本网站《隐私声明》之规范。 报名服务平台不会在未经合法用户授权时，公开、编辑或透露其信息及保存在平台中的非公开内容，除非有下列情况： 有关法律规定或报名服务平台合法服务程序规定； 在紧急情况下，为维护用户及公众的权益； 为维护系统的知识产权和其他重要权利； 其它需要公开、编辑或透露用户信息的情况。
      </p>
      <p>6 法律</p>
      <p>本条款适用中华人民共和国的法律，并且排除一切冲突法规定的适用。</p>
      <p>7 其它</p>
      <p>如本服务条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力。</p>
      <p>本服务条款构成您与报名服务平台的全部协议，规范您对本服务的使用。</p>
      <p>本公司保留本服务条款的解释权。</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="on_disagree">不同意</el-button>
      <el-button type="primary" @click="on_agree">同意</el-button>
    </div>
  </el-dialog>
</template>
<script type="text/ecmascript-6">
export default {
  data: function() {
    return {
      myResult: this.dialogFormVisible,
      agreeData: this.agree
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    agree: {
      type: Boolean
    }
  },
  watch: {
    dialogFormVisible(val) {
      this.myResult = val;
    },
    agree(val) {
      this.agreeData = val;
    },
    myResult(val) {
      this.$emit("on-result-change", [val, this.agreeData]);
    }
  },
  methods: {
    on_agree: function() {
      this.agreeData = true;
      this.myResult = false;
    },
    on_disagree: function() {
      this.agreeData = false;
      this.myResult = false;
    }
  }
};
</script>
<style >
.el-dialog__body{
  box-sizing: border-box;
}
</style>